import { BaseStore } from "../stores/base_store"
import { makeAutoObservable } from "mobx"
import CallAPI from "../api/call_api"

export type CallProps = {
    key: string;
    associated_type: string;
    associated_uuid: string;
    identity: string;

    number_to: string;
    number_from: string;

    twilio_call_sid: string;
    twilio_duration: string;
    twilio_price: string;
    twilio_status: string;

    date_created: string;
    date_updated: string;
    updateProps?: (attributes: CallProps) => void;
};

// Domain object Call
export class Call implements CallProps {
    key = "";
    associated_type = "";
    associated_uuid = "";
    identity = "";

    number_to = "";
    number_from = "";

    twilio_call_sid = "";
    twilio_duration = "";
    twilio_price = "";
    twilio_status = "";

    date_created = "";
    date_updated = "";

    constructor(attributes: CallProps) {
        makeAutoObservable(this, {
            updateProps: false
        })
        if (attributes) {
            this.updateProps(attributes);
        }
    }

    updateProps(attributes: CallProps) {
		this.key = attributes.key;
        this.associated_type = attributes.associated_type;
        this.associated_uuid = attributes.associated_uuid;
		this.identity = attributes.identity;
		this.number_to = attributes.number_to;
		this.number_from = attributes.number_from;
		this.twilio_call_sid = attributes.twilio_call_sid;
        this.twilio_duration = attributes.twilio_duration;
        this.twilio_price = attributes.twilio_price;
        this.twilio_status = attributes.twilio_status;
        this.date_created = attributes.date_created;
        this.date_updated = attributes.date_updated;
    }

}


export class CallStore extends BaseStore<CallProps, Call> {


    async fetchCallsByAssociation(associated_type: string, associated_uuid: string, identityKey: string, cursor = "") {
        return CallAPI.fetchByAssociation(associated_type, associated_uuid, identityKey, cursor)
            .then((resp) => {
                this.receiveUpdate(resp.items);
                if (resp.cursor) {
                    this.fetchCallsByAssociation(associated_type, associated_uuid, identityKey, resp.cursor);
                }
                return resp.items;
            });
    }


    modelConstructor() {
        return Call;
    }

}
